import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalState } from "../../contexts/GlobalContext";


const Mypage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { setStateValue } = useGlobalState();

  const [visibleForms, setVisibleForms] = useState<{ [key: string]: boolean }>({
    email: true,
    password: false,
    profile: false,
    company: false,
  });

  const handleClickIconVisibleForm = (key: string) => {
    setVisibleForms((prev) => ({
      ...prev,
      [key]: !prev[key], 
    }));
  };

  return (
    <div className="page__user">
      {/* <div className="text-center mb40">
        <img src="/images/service-top.jpg" alt="" className="img-responsive" />
      </div>
      <h2 className="text-center mb32">
        <img
          className="center-block service-tit-1"
          src="/images/service_tit.jpg"
          alt={t("features.userTop.serviceTit")}
        />
      </h2>
      <ul className="service-list-horizontal">
        <li>
          <a
            href="http://www.sendenkaigi.com/?_gl=1*15e1z1g*_gcl_au*NDg4Mzc4MTYuMTcyODYyODI5My4xMjMxMTAwMTQ0LjE3Mjk4NDI0ODkuMTcyOTg0MjQ4OA..*_ga*MTM2NjMxMTM1NC4xNzI4NjI4Mjkz*_ga_HXZQFZ3MR4*MTczMTM5MzcyOS4xMTAuMS4xNzMxMzk0MTE3LjYwLjAuMA.."
            target="_blank"
          >
            <div className="tit-service-item-horizontal">
              <div className="thumb-service-item-horizontal">
                <img src="/images/ico10.gif" />
              </div>
              <h3>{t("features.userTop.sendenkaigiOnline")}</h3>
            </div>
            <div className="description-service-item-horizontal">
              <p>{t("features.userTop.sendenkaigiOnlineContent")}</p>
            </div>
          </a>
        </li>

        <li>
          <a href="http://mag.sendenkaigi.com/senden/" target="_blank">
            <div className="tit-service-item-horizontal">
              <div className="thumb-service-item-horizontal">
                <img src="/images/ico01.gif" />
              </div>
              <h3>{t("features.userTop.digitalMagazine")}</h3>
            </div>
            <div className="description-service-item-horizontal">
              <p>{t("features.userTop.digitalMagazineContent")}</p>
            </div>
          </a>
        </li>

        <li>
          <a href="http://mag.sendenkaigi.com/hansoku/" target="_blank">
            <div className="tit-service-item-horizontal">
              <div className="thumb-service-item-horizontal">
                <img src="/images/ico02.gif" />
              </div>
              <h3>{t("features.userTop.hansokuTit")}</h3>
            </div>
            <div className="description-service-item-horizontal">
              <p>{t("features.userTop.hansokuContent")}</p>
            </div>
          </a>
        </li>

        <li>
          <a href="http://mag.sendenkaigi.com/kouhou/" target="_blank">
            <div className="tit-service-item-horizontal">
              <div className="thumb-service-item-horizontal">
                <img src="/images/ico03.gif" />
              </div>
              <h3> {t("features.userTop.kouhouTit")}</h3>
            </div>
            <div className="description-service-item-horizontal">
              <p>{t("features.userTop.kouhouContent")}</p>
            </div>
          </a>
        </li>

        <li>
          <a href="http://mag.sendenkaigi.com/brain/" target="_blank">
            <div className="tit-service-item-horizontal">
              <div className="thumb-service-item-horizontal">
                <img src="/images/ico12.gif" />
              </div>
              <h3>{t("features.userTop.brainTit")}</h3>
            </div>
            <div className="description-service-item-horizontal">
              {t("features.userTop.brainContent")}
            </div>
          </a>
        </li>

        <li>
          <a href="http://www.advertimes.com/" target="_blank">
            <div className="tit-service-item-horizontal">
              <div className="thumb-service-item-horizontal">
                <img src="/images/ico04.gif" alt="AdverTimes" />
              </div>
              <h3>
                AdverTimes<ruby>アドタイ</ruby>
              </h3>
            </div>
            <div className="description-service-item-horizontal">
              {t("features.userTop.advertimesContent")}
            </div>
          </a>
        </li>

        <li>
          <a href="https://hansoku.co/" target="_blank">
            <div className="tit-service-item-horizontal">
              <div className="thumb-service-item-horizontal">
                <img src="/images/hansokukonpe-icon.jpg" />
              </div>
              <h3> {t("features.userTop.hansokukonpeTit")}</h3>
            </div>
            <div className="description-service-item-horizontal">
              <p>{t("features.userTop.hansokukonpeContent")}</p>
            </div>
          </a>
        </li>

        <li>
          <a href="https://senden.co/" target="_blank">
            <div className="tit-service-item-horizontal">
              <div className="thumb-service-item-horizontal">
                <img src="/images/award-sendenkaigi-icon.jpg" />
              </div>
              <h3>{t("features.userTop.awardSendenkaigiTit")}</h3>
            </div>
            <div className="description-service-item-horizontal">
              <p>{t("features.userTop.awardSendenkaigiContent")}</p>
            </div>
          </a>
        </li>

        <li>
          <a href="https://bova.co/" target="_blank">
            <div className="tit-service-item-horizontal">
              <div className="thumb-service-item-horizontal">
                <img src="/images/bova-icon.jpg" />
              </div>
              <h3>{t("features.userTop.bovaTit")}</h3>
            </div>
            <div className="description-service-item-horizontal">
              <p>{t("features.userTop.bovaContent")}</p>
            </div>
          </a>
        </li>
      </ul> */}
    </div>
  );
};

export default Mypage;
